import React from "react";
import Container from "./Container";
import MultiCrousel from "./MultiCrousel";
import SectionCount from "./SectionCount";
import {
  FcBullish,
  FcDepartment,
  FcInspection,
  FcOnlineSupport,
} from "react-icons/fc";
function TopCities() {
  const sectionCounts = [
    {
      num: 3500,
      text: "Properties Sold",
      color:"red",
      Icon: <FcBullish size={42} />,
    },
    {
      num: 230,
      text: "Projects Handled",
      Icon: <FcDepartment size={42} />,
    },
    {
      num: 400,
      text: "NRI Clients Served",
      Icon: <FcOnlineSupport size={42} />,
    },
    {
      num: 40,
      text: "Builders, Marketing Partners",
      Icon: <FcInspection size={42} />,
    },
  ];
  const Featured = [
    {
      key: 1,
      title: "",
      description: "",
      price: "9000000",
      imgUrl: "/h1.jpg",
    },
    {
      key: 2,
      title: "",
      description: "",
      price: "1000000",
      imgUrl: "/h2.jpg",
    },
    {
      key: 3,
      title: "",
      description: "",
      price: "6000000",
      imgUrl: "/h3.jpg",
    },
  ];
  return (
    <div>
      <Container className={"md:flex justify-between md:py-20 gap-5 padingm "}>
        <div className="mt-4 space-y-5 left">
          <h2>Properties In Top Cities</h2>
          <p>
            Find the home of your dreams at the finest cities of India with the
            budget you prefer. Explore apartments, villas, plots and farmlands
            across the nation.
          </p>
          <SectionCount numbers={sectionCounts} />
        </div>
        <div className="shadow-md   md:w-[52%] mt-3 md:mt-0">
        <MultiCrousel data={Featured} autoplay={true} />
        </div>
      </Container>
    </div>
  );
}

export default TopCities;
